module.exports = __webpack_public_path__ + "img/flag_3.4049693e.png";